<template>
  <Drawer
    :width="AddNewSalesRecipeDrawerOpened ? 1000 : 800"
    :title="openedSales && openedSales.customer.name"
    v-model="drawerOpened"
    class="drawer-body"
  >
    <Modal v-model="delRecipeModal" title="删除配方" @on-ok="confirmDelRecipe">
      <p>你确认删除此配方吗？</p>
    </Modal>
    <AddNewSalesRecipeDrawer
      v-if="AddNewSalesRecipeDrawerOpened"
      ref="AddNewSalesRecipeDrawer"
      @closeDrawer="closeAddRecipeDrawer"
    />

    <div v-else class="drawer-content">
      <div class="info-data">
        <div class="sec-title">
          <h2>
            产品：{{
              openedSales &&
              openedSales.material.model + openedSales.material.name
            }}
          </h2>
        </div>
        <Button
          type="primary"
          long
          @click="createNewRecipe"
          style="margin-top: 12px"
          >创建配方</Button
        >

        <div class="sec-title">生产配方</div>
        <RecipeCard
          v-if="prodRecipe"
          :recipe="prodRecipe"
          @click.native="recipedClicked(prodRecipe)"
          :active="prodRecipe._id === selectedRecipe._id"
        />
        <Alert v-else type="warning" style="margin-top: 12px"
          >暂无生产配方</Alert
        >

        <div class="sec-title">配方列表</div>
        <Alert
          v-if="recipeSalesList.length <= 0"
          type="warning"
          style="margin-top: 12px"
          >暂无配方</Alert
        >
        <RecipeCard
          v-for="r in recipeSalesList"
          :recipe="r"
          v-else
          @click.native="recipedClicked(r)"
          :key="r._id"
          :active="r._id === selectedRecipe._id"
        />
      </div>
      <div class="recipe-data">
        <div v-if="selectedRecipe._id">
          <div class="recipe-top">
            <div>
              <h1>{{ selectedRecipe.name }}</h1>
            </div>
            <div class="action-button">
              <Button
                @click="calcRecipeCostMethod"
                type="info"
                ghost
                size="small"
                >计算成本</Button
              >
              <Button
                @click="setProdRecipeSalesMethod"
                type="info"
                ghost
                size="small"
                >设为生产配方</Button
              >
              <Button @click="copyRecipe" type="info" ghost size="small"
                >复制配方</Button
              >
              <Button
                @click="clickDelRecipeModal"
                type="error"
                ghost
                size="small"
                >删除</Button
              >
              <!-- <Dropdown
                trigger="hover"
                @on-click="clickActionDropDown"
                transfer
              >
                <a>
                  <Icon type="ios-menu" size="28" />
                </a>
                <DropdownMenu slot="list">
                  <div>
                    <DropdownItem :name="`del`">删除</DropdownItem>
                  </div>
                </DropdownMenu>
              </Dropdown> -->
            </div>
          </div>
          <div class="recipe-info">
            <div>
              <div>配方编号: #{{ selectedRecipe.NoId }}</div>
              <div>审核情况: {{ statusToText(selectedRecipe.status) }}</div>
            </div>
            <div>
              <div v-if="selectedRecipe.createdBy">
                创建人: {{ selectedRecipe.createdBy.name }}
              </div>
              <!-- <div>审核人: ys</div> -->
            </div>
            <div>审核时间: {{ dayjs(selectedRecipe.createdAt) }}</div>
          </div>
          <RecipeTable ref="RecipeTable" />
        </div>
        <Alert v-else type="warning">暂无配方</Alert>
      </div>
    </div>
  </Drawer>
</template>

<script>
import RecipeCard from "../RecipePage/RecipeCard.vue";
import RecipeTable from "../RecipePage/RecipeTable.vue";
import { mapState, mapActions } from "vuex";
import AddNewSalesRecipeDrawer from "../RecipePage/AddNewSalesRecipeDrawer.vue";
import dayjs from "dayjs";

export default {
  name: "RecipeDrawer",
  components: {
    RecipeCard,
    RecipeTable,
    AddNewSalesRecipeDrawer,
  },
  props: [],
  data() {
    return {
      drawerOpened: false,
      openedSales: null,
      AddNewSalesRecipeDrawerOpened: false,
      openedRecipe: null,
      selectedRecipe: {},
      prodRecipe: null,
      delRecipeModal: false,
    };
  },
  methods: {
    ...mapActions({
      getSalesCurrentRecipeProd: "recipeSales/getSalesCurrentRecipeProdAction",
      getRecipeSalesById: "recipeSales/getRecipeSalesByIdAction",
      getRecipeSales: "recipeSales/getRecipeSalesAction",
      setProdRecipeSales: "recipeSales/setProdRecipeSalesAction",
      deleteRecipeSales: "recipeSales/deleteRecipeSalesAction",
      setProdRecipeupdateSales: "sales/setProdRecipeupdateSalesAction",
      calcSalesCostById: "caclSalesCost/calcSalesCostByIdAction",
    }),
    dayjs(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm");
    },
    statusToText(status) {
      if (this.recipeType) {
        return "";
      } else {
        if (status === "verified" || status === "合格") {
          return "合格";
        } else if (status === "rejected" || status === "不合格") {
          return "不合格";
        } else if (status === "canceled" || status === "弃用") {
          return "已取消";
        } else {
          return "待审核";
        }
      }
    },
    async recipedClicked(r) {
      this.selectedRecipe = await this.getRecipeSalesById(r._id);
      setTimeout(() => {
        this.$refs.RecipeTable.loadRecipe(this.selectedRecipe._id, "sales");
      }, 0);
    },
    resetSelectedRecipe() {
      this.selectedRecipe = {};
    },
    async openDrawer(sales, refresh) {
      this.prodRecipe = null;
      this.resetSelectedRecipe();
      this.drawerOpened = true;
      this.AddNewSalesRecipeDrawerOpened = false;
      this.openedSales = sales;
      this.selectedProductId = sales.material._id;
      try {
        // 2. 获取配方列表
        await this.getRecipeSales({
          sales: sales._id,
        });
        if (refresh) {
          // 1. 获取生产配方
          this.prodRecipe = await this.getSalesCurrentRecipeProd(sales._id);
        } else if (sales.prodRecipe) {
          this.prodRecipe = sales.prodRecipe;
        }
        if (this.prodRecipe) {
          this.selectedRecipe = this.prodRecipe;
        } else if (this.recipeSalesList.length > 0) {
          this.selectedRecipe = this.recipeSalesList[0];
        }
        if (this.selectedRecipe) {
          for (let i = 0; i < this.selectedRecipe.detail.length; i++) {
            this.selectedRecipe.detail[i] = {
              ...this.selectedRecipe.detail[i].material,
              ratio: this.selectedRecipe.detail[i].ratio,
            };
          }
        }
        if (this.selectedRecipe._id) {
          setTimeout(() => {
            this.$refs.RecipeTable.loadRecipe(this.selectedRecipe._id, "sales");
          }, 0);
        }
      } catch (error) {
        this.$Message.error(`获取产品失败: ${error}`);
      }
    },
    createNewRecipe() {
      this.AddNewSalesRecipeDrawerOpened = true;
      this.$nextTick(() => {
        this.$refs.AddNewSalesRecipeDrawer.openDrawer(
          this.openedSales._id,
          this.openedSales.customer,
          this.openedSales.material
        );
      });
    },
    closeAddRecipeDrawer(newRecipe) {
      this.AddNewSalesRecipeDrawerOpened = false;
      this.$nextTick(() => {
        if (newRecipe) {
          this.openDrawer(this.openedSales);
        }
      });
    },
    async calcRecipeCostMethod() {
      try {
        await this.calcSalesCostById({ sales: this.openedSales._id });
        this.$Message.success("计算完成");
      } catch (error) {
        this.$Message.error("计算失败，" + error);
      }
    },
    async setProdRecipeSalesMethod() {
      try {
        await this.setProdRecipeSales({
          id: this.selectedRecipe._id,
        });
        this.prodRecipe = this.selectedRecipe;
        this.openedSales.prodRecipe = this.prodRecipe;
        this.setProdRecipeupdateSales(this.openedSales);
        this.$Message.success("设置成功");
      } catch (error) {
        this.$Message.error("设置失败" + error);
      }
    },
    copyRecipe() {
      this.AddNewSalesRecipeDrawerOpened = true;
      this.$nextTick(() => {
        this.$refs.AddNewSalesRecipeDrawer.openDrawer(
          this.openedSales._id,
          this.openedSales.customer,
          this.openedSales.material,
          this.selectedRecipe
        );
      });
    },
    // clickActionDropDown(name) {
    //   switch (name) {
    //     case "del":
    //       this.delRecipeModal = true;
    //       break;
    //   }
    // },
    clickDelRecipeModal() {
      this.delRecipeModal = true;
    },
    async confirmDelRecipe() {
      try {
        await this.deleteRecipeSales({ id: this.selectedRecipe._id });
        this.$$Message.success("删除成功");
      } catch (error) {
        this.$$Message.error("删除失败" + error);
      }
    },
    CASummary({ columns, data }) {
      const sums = {};
      columns.forEach((column, index) => {
        const key = column.key;
        if (index === 0) {
          sums[key] = {
            key,
            value: "总价",
          };
          return;
        }
        if (index === 1) {
          sums[key] = {
            key,
            value: null,
          };
          return;
        }
        const values = data.map((item) => Number(item[key]));
        if (!values.every((value) => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (index === 2) {
            sums[key] = {
              key,
              value: (v * 100).toFixed(2) + " %",
            };
          } else {
            sums[key] = {
              key,
              value: v.toFixed(2),
            };
          }
        } else {
          sums[key] = {
            key,
            value: "N/A",
          };
        }
      });

      return sums;
    },
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.auth.currentUser,
      recipeSalesList: (state) => state.recipeSales.recipeSalesList,
    }),
  },
};
</script>

<style scoped lang="stylus">
.info-data
  width 300px
  padding-right 20px
  height 100%
  float left
  overflow-y auto

  > .sec-title ~ .sec-title
    margin-top 16px

  .sec-title
    margin-bottom 8px

.action-button
  button
    margin-left 8px

.recipe-data
  margin-left 16px
  height 100%
  width 445px
  float left
  overflow-y auto

.recipe-top
  display flex
  justify-content space-between

.recipe-info
  width 250px

.recipe-info>div
  display flex
  justify-content space-between
  font-size 14px

.sec-title
  width 100%
  font-weight 800
</style>
